import React from 'react';
import { Card } from 'antd';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import colors from '../../../../utils/theme/colors';

/**
 * JsonBeautifyTab
 * Shows a prettified JSON object/array with VS Code-like styling.
 * Usage: <JsonBeautifyTab data={arrayOrObject} />
 */
export const JsonBeautifyTab = ({ data }) => (
  <Card
    bodyStyle={{ padding: 0, background: colors.secondary }}
    style={{
      borderRadius: 8,
      marginTop: 16,
      background: colors.secondary,
      color: colors.foreground,
    }}
  >
    <SyntaxHighlighter
      language='json'
      style={vscDarkPlus}
      customStyle={{
        margin: 0,
        background: colors.secondary,
        fontSize: 14,
        color: colors.foreground,
      }}
      wrapLongLines
    >
      {JSON.stringify(data, null, 2)}
    </SyntaxHighlighter>
  </Card>
);

export default JsonBeautifyTab;
